import { useTranslation } from '@klv/hooks/useTranslation';
import { useInstantSearch } from 'react-instantsearch';

import { generateClassName } from '@klv/shared/utils/functions';
import useAlgoliaHits from '@klv/organisms/unified-search/hooks/use-algolia-hits';

import * as styles from './styles/whatsNew.module.css';
import type { IWhatsNewNoResults } from './types';

export const NoResults = ({
  className = '',
  query,
  ...props
}: IWhatsNewNoResults) => {
  
  const { t } = useTranslation();

  return (
    <div className={generateClassName([className, styles.whatsNewNoResults])} {...props}>
      <div className={styles.title}>{t('pages_search_noResultsTitle', { query })}</div>
      <div className={generateClassName([styles.subTitle, 'p2'])}>{t('pages_search_noResultsSubTitle')}</div>
    </div>
  );
};

export const WhatsNewNoResults = (props: IWhatsNewNoResults) => {
  const { uiState } = useInstantSearch();
  const { totalHits } = useAlgoliaHits();
  const query = Object.values(uiState).find(child => child.query)?.query || '';
  
  if (!query || totalHits > 0) return null;

  return <NoResults {...props} query={query} />;
};

export default WhatsNewNoResults;
